import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { Route } from '../core/enums/route.enum';
import { AppConfigService } from '@app/core/services/config.service';

const AUTH0_TOKEN_PREFIX = 'capacitor-storage_@@auth0spajs@@';

export const impersonationGuard = (route: ActivatedRouteSnapshot): UrlTree | boolean => {
  const router = inject(Router);
  const configService = inject(AppConfigService);

  const actAs = route.queryParamMap?.get('actAs');
  const accessToken = route.queryParamMap?.get('accessToken');
  const idToken = route.queryParamMap?.get('idToken');

  if (actAs && accessToken && idToken) {
    sessionStorage.setItem('actAs', actAs);

    // Store the access token in localStorage
    localStorage.setItem(
      `${AUTH0_TOKEN_PREFIX}::${configService.config?.security?.auth0?.clientId}::${configService.config?.security?.auth0?.audience}::openid profile email offline_access`,
      JSON.stringify({
        body: {
          access_token: accessToken,
        },
      })
    );

    // Store the id token in localStorage
    localStorage.setItem(
      `${AUTH0_TOKEN_PREFIX}::${configService.config?.security?.auth0?.clientId}::@@user@@`,
      JSON.stringify({
        decodedToken: {
          claims: jwtDecode(idToken),
          user: jwtDecode(idToken),
        },
        id_token: idToken,
      })
    );

    return router.createUrlTree([Route.Home]);
  }

  return true;
};
